/* =========================================================
   PANEL LED V4 — 1A CONFIG
   Mühür: PANEL-V4-1A-CLEAN-SHELL-DATA-ADAPTER-PREVIEW
   Amaç: COB namespace taşımadan Panel LED V4 için tek kaynak config.
   ========================================================= */
(function (window) {
  "use strict";

  if (window.GDX_PANEL_LED_V4_CONFIG) return;

  window.GDX_PANEL_LED_V4_CONFIG = {
    ok: true,
    namespace: "GDX_PANEL_LED_V4",
    version: "PANEL-V4-1A-CLEAN-SHELL-DATA-ADAPTER-PREVIEW",
    collectionHandle: "panel-video-led-isiklar-1",
    collectionUrl: "/collections/panel-video-led-isiklar-1/products.json?limit=250",
    etap2Catalog: Object.freeze({
      version: "PANEL-V4-ETAP2-R1-CATALOG-LANE-SHADOW-V1",
      mode: "SHADOW_ONLY",
      sources: Object.freeze([
        Object.freeze({
          key: "PANEL_BARE_DISCOVERY",
          handle: "panel-video-led-isiklar-1",
          url: "/collections/panel-video-led-isiklar-1/products.json?limit=250",
          laneHint: "BARE"
        }),
        Object.freeze({
          key: "PANEL_SET_DISCOVERY",
          handle: "panel-video-led-isiklar",
          url: "/collections/panel-video-led-isiklar/products.json?limit=250",
          laneHint: "SET_DISCOVERY"
        })
      ]),
      mutateStateProducts: false,
      scoringMutation: false,
      rankingMutation: false,
      fpMutation: false,
      setupMutation: false,
      commerceMutation: false
    }),
    pageKey: "panel-led-karsilastirma-motoru-v1",

    labels: {
      launcherTitle: "PANEL LED KARŞILAŞTIR",
      launcherSubTitle: "V4 temiz veri motoru",
      panelTitle: "Panel LED Karşılaştırma Motoru V4",
      panelSubtitle: "Panel LED ürünlerini temiz veri mimarisiyle yükler; karşılaştırma, öneri ve paylaşım modülleri ayrı bağlanır."
    },

    filters: [
      { key: "all", label: "Tümü" },
      { key: "rgb", label: "RGB Panel" },
      { key: "bicolor", label: "Bi-Color" },
      { key: "battery", label: "Batarya / V-Mount" },
      { key: "dmx", label: "DMX / Pro Kontrol" },
      { key: "gdx", label: "GDX" },
      { key: "godox", label: "Godox" },
      { key: "instock", label: "Stokta" }
    ],

    phaseLocks: {
      compareCore: false,
      recommenderCore: false,
      shareCore: false,
      commerceCore: false,
      legacyCobNamespace: false
    },

    moduleOwners: {
      data: "panel-led-v4.data.js",
      ui: "panel-led-v4.ui.js",
      compare: "PANEL-V4-1B-PLANNED",
      recommender: "PANEL-V4-2A-PLANNED",
      share: "PANEL-V4-3A-PLANNED",
      commerce: "PANEL-V4-4A-PLANNED"
    }
  };
})(window);